import script from "./SectionSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionSelect.vue?vue&type=script&setup=true&lang=js"

import "./SectionSelect.vue?vue&type=style&index=0&id=3f2b38aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f2b38aa"]])

export default __exports__